import { Grid, GridRow, Input, ModalBottomButtons } from '@bp/ui-components';
import { Formik, FormikHelpers } from 'formik';
import { useTranslation } from 'react-i18next';
import { Form } from 'react-router-dom';
import { useMemorizedCacheTag } from '../../../hooks/useMemorizedCacheTag';
import { use_CancelEventMutation } from '../../../types/planung-graphql-client-defs';

type CancelEventFormType = {
  comment: string;
};

type CancelEventFormProps = {
  eventUuid: string;
  substitutionComment: string;
  onLoad: (loading: boolean) => void;
  onClose: () => void;
};

export const CancelEventForm = ({ eventUuid, substitutionComment, onLoad, onClose }: CancelEventFormProps) => {
  const { t } = useTranslation();

  const [, cancelEvent] = use_CancelEventMutation();

  const initialValues: CancelEventFormType = {
    comment: substitutionComment,
  };
  const eventContext = useMemorizedCacheTag('EVENT');

  async function handleSubmit(values: CancelEventFormType, formHelpers: FormikHelpers<CancelEventFormType>) {
    onLoad(true);
    await cancelEvent(
      {
        eventUuid: eventUuid,
        substitutionComment: values.comment,
      },
      eventContext,
    );
    onLoad(false);
    onClose();
  }

  return (
    <Formik<CancelEventFormType> initialValues={initialValues} onSubmit={handleSubmit}>
      {({ setFieldValue, values, isSubmitting, dirty, resetForm, submitForm }) => {
        return (
          <Form>
            <Grid useFormGap>
              <GridRow>
                <Input
                  name='comment'
                  label={t('common.comment')}
                  onChange={async (e) => setFieldValue('comment', e.target.value)}
                  value={values.comment}
                />
              </GridRow>
            </Grid>

            <ModalBottomButtons
              closeButton={{
                callback: () => {
                  onClose();
                  resetForm();
                },
              }}
              submitButton={{
                disabled: isSubmitting,
                callback: async () => {
                  await submitForm();
                },
              }}
            />
          </Form>
        );
      }}
    </Formik>
  );
};
